import { Component, Input } from '@angular/core';
import { PatientPrintModel } from './patient-print.model';

@Component({
  selector: 'app-patient-print',
  standalone: false,
  templateUrl: './patient-print.component.html',
  styleUrl: './patient-print.component.scss'
})
export class PatientPrintComponent {
  @Input() patient: PatientPrintModel | null = null;
  @Input() clinicName?: string;
  @Input() doctorName?: string;

  /**
   * Print is handled by PatientPrintWindowService (dedicated popup).
   * This component is used for preview only in the modal.
   */
  printPatientForm(): void {
    // No-op: actual print is triggered via PatientPrintWindowService from parent.
  }

  /** Safe display value for template (handles null/undefined). */
  safe(value: string | undefined | null): string {
    return value != null && String(value).trim() !== '' ? String(value).trim() : '—';
  }
}
